import { ThemeConfig } from './types';

/**
 * Tailwind CSS 调色板参考（维护者参考）
 * 
 * Slate: #f8fafc #f1f5f9 #e2e8f0 #cbd5e1 #94a3b8 #64748b #475569 #334155 #1e293b #0f172a
 * Blue:  #eff6ff #dbeafe #bfdbfe #93c5fd #60a5fa #3b82f6 #2563eb #1d4ed8 #1e40af #1e3a8a
 * Green: #f0fdf4 #dcfce7 #bbf7d0 #86efac #4ade80 #22c55e #16a34a #15803d #166534 #14532d
 * Amber: #fffbeb #fef3c7 #fde68a #fcd34d #fbbf24 #f59e0b #d97706 #b45309 #92400e #78350f
 * Red:   #fef2f2 #fee2e2 #fecaca #fca5a5 #f87171 #ef4444 #dc2626 #b91c1c #991b1b #7f1d1d
 * Cyan:  #ecfeff #cffafe #a5f3fc #67e8f9 #22d3ee #06b6d4 #0891b2 #0e7490 #155e75 #164e63
 */

export const lightTheme: ThemeConfig = {
    name: 'light',

    primary: '#2563eb',
    primaryHover: '#1d4ed8',
    primaryActive: '#1e40af',
    primarySubtle: 'rgba(37, 99, 235, 0.1)',

    success: '#16a34a',
    successHover: '#15803d',
    successSubtle: 'rgba(22, 163, 74, 0.1)',

    warning: '#d97706',
    warningHover: '#b45309',
    warningSubtle: 'rgba(217, 119, 6, 0.1)',

    danger: '#dc2626',
    dangerHover: '#b91c1c',
    dangerSubtle: 'rgba(220, 38, 38, 0.1)',

    info: '#0891b2',
    infoHover: '#0e7490',
    infoSubtle: 'rgba(8, 145, 178, 0.1)',

    bgBase: '#f8fafc',
    bgElevated: '#ffffff',
    bgOverlay: 'rgba(255, 255, 255, 0.98)',
    bgInset: '#f1f5f9',
    bgGlass: 'rgba(255, 255, 255, 0.8)',
    bgGlassBlur: '24px',

    textPrimary: '#0f172a',
    textSecondary: '#475569',
    textTertiary: '#94a3b8',
    textDisabled: '#cbd5e1',
    textInverse: '#ffffff',
    textLink: '#2563eb',
    textLinkHover: '#1d4ed8',

    iconDefault: '#64748b',
    iconHover: '#334155',
    iconActive: '#2563eb',
    iconDisabled: '#cbd5e1',
    iconInverse: '#ffffff',

    borderDefault: '#e2e8f0',
    borderSubtle: '#f1f5f9',
    borderStrong: '#cbd5e1',
    borderDisabled: '#f1f5f9',
    divider: '#e2e8f0',

    componentBg: 'transparent',
    componentBgHover: 'rgba(15, 23, 42, 0.04)',
    componentBgActive: 'rgba(15, 23, 42, 0.08)',
    componentBgSelected: 'rgba(37, 99, 235, 0.08)',
    componentBgDisabled: '#f8fafc',

    focusRing: 'rgba(37, 99, 235, 0.5)',
    focusRingOffset: '#ffffff',
    selectionBg: 'rgba(37, 99, 235, 0.15)',
    selectionText: '#0f172a',

    shadowSm: '0 2px 8px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.08)',
    shadowMd: '0 4px 12px rgba(0, 0, 0, 0.12), 0 6px 20px rgba(0, 0, 0, 0.1)',
    shadowLg: '0 10px 25px rgba(0, 0, 0, 0.15), 0 6px 10px rgba(0, 0, 0, 0.1)',
    shadowXl: '0 20px 40px rgba(0, 0, 0, 0.2), 0 10px 15px rgba(0, 0, 0, 0.1)',
    shadowGlow: '0 2px 8px rgba(59, 130, 246, 0.3), 0 4px 16px rgba(59, 130, 246, 0.2)',

    scrollbarTrack: '#f1f5f9',
    scrollbarThumb: '#cbd5e1',
    scrollbarThumbHover: '#94a3b8',

    floatingBg: 'rgba(255, 255, 255, 0.8)',
    floatingBorder: 'rgba(226, 232, 240, 0.5)',
    floatingShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
    floatingBtnBg: 'rgba(255, 255, 255, 0.9)',
    floatingBtnBorder: 'rgba(203, 213, 225, 0.6)',
    floatingBtnShadow: '0 2px 8px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.08)',
    floatingBtnBgHover: '#ffffff',
    floatingBtnShadowHover: '0 4px 12px rgba(0, 0, 0, 0.12), 0 6px 20px rgba(0, 0, 0, 0.1)',
    floatingIconColor: '#334155',
    floatingIconColorHover: '#1e293b',

    panelBg: 'rgba(255, 255, 255, 0.95)',
    panelBorder: 'rgba(226, 232, 240, 0.6)',
    panelHeaderBg: 'rgba(248, 250, 252, 0.9)',
    panelRadius: '12px',

    tabBg: '#f1f5f9',
    tabItemBg: 'transparent',
    tabItemBgHover: 'rgba(255, 255, 255, 0.6)',
    tabItemBgActive: '#ffffff',
    tabItemTextActive: '#2563eb',

    overrides: {
        dialog: {
            headerBg: '#f8fafc',
        },
        toolbar: {
            bg: 'rgba(255, 255, 255, 0.9)',
            buttonBg: 'rgba(255, 255, 255, 0.95)',
            buttonBgHover: '#ffffff',
            buttonBgActive: '#2563eb',
        },
        input: {
            bg: '#ffffff',
            bgFocus: '#ffffff',
            placeholder: '#94a3b8',
        },
    },
};

export const darkTheme: ThemeConfig = {
    name: 'dark',

    primary: '#3b82f6',
    primaryHover: '#60a5fa',
    primaryActive: '#2563eb',
    primarySubtle: 'rgba(59, 130, 246, 0.15)',

    success: '#22c55e',
    successHover: '#4ade80',
    successSubtle: 'rgba(34, 197, 94, 0.15)',

    warning: '#f59e0b',
    warningHover: '#fbbf24',
    warningSubtle: 'rgba(245, 158, 11, 0.15)',

    danger: '#ef4444',
    dangerHover: '#f87171',
    dangerSubtle: 'rgba(239, 68, 68, 0.15)',

    info: '#06b6d4',
    infoHover: '#22d3ee',
    infoSubtle: 'rgba(6, 182, 212, 0.15)',

    bgBase: '#152232',
    bgElevated: '#1f2d3e',
    bgOverlay: 'rgba(21, 34, 50, 0.98)',
    bgInset: '#152232',
    bgGlass: 'rgba(21, 34, 50, 0.85)',
    bgGlassBlur: '24px',

    textPrimary: '#ffffff',
    textSecondary: '#94a3b8',
    textTertiary: '#64748b',
    textDisabled: '#475569',
    textInverse: '#152232',
    textLink: '#60a5fa',
    textLinkHover: '#93c5fd',

    iconDefault: '#ffffff',
    iconHover: '#ffffff',
    iconActive: '#3b82f6',
    iconDisabled: '#475569',
    iconInverse: '#152232',

    borderDefault: 'rgba(51, 65, 85, 0.5)',
    borderSubtle: 'rgba(51, 65, 85, 0.5)',
    borderStrong: '#475569',
    borderDisabled: '#1e293b',
    divider: '#334155',

    componentBg: 'transparent',
    componentBgHover: 'rgba(248, 250, 252, 0.06)',
    componentBgActive: 'rgba(248, 250, 252, 0.1)',
    componentBgSelected: 'rgba(59, 130, 246, 0.2)',
    componentBgDisabled: '#1e293b',

    focusRing: 'rgba(59, 130, 246, 0.5)',
    focusRingOffset: '#1e293b',
    selectionBg: 'rgba(59, 130, 246, 0.3)',
    selectionText: '#f8fafc',

    shadowSm: '0 2px 8px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3)',
    shadowMd: '0 4px 12px rgba(0, 0, 0, 0.5), 0 6px 20px rgba(0, 0, 0, 0.4)',
    shadowLg: '0 10px 25px rgba(0, 0, 0, 0.6), 0 6px 10px rgba(0, 0, 0, 0.4)',
    shadowXl: '0 20px 40px rgba(0, 0, 0, 0.7), 0 10px 15px rgba(0, 0, 0, 0.5)',
    shadowGlow: '0 2px 8px rgba(59, 130, 246, 0.4), 0 4px 16px rgba(59, 130, 246, 0.25)',

    scrollbarTrack: '#1e293b',
    scrollbarThumb: '#475569',
    scrollbarThumbHover: '#64748b',

    floatingBg: 'rgba(15, 23, 42, 0.85)',
    floatingBorder: 'rgba(51, 65, 85, 0.4)',
    floatingShadow: '0 4px 24px rgba(0, 0, 0, 0.25)',
    floatingBtnBg: 'rgba(51, 65, 85, 0.6)',
    floatingBtnBorder: 'rgba(100, 116, 139, 0.5)',
    floatingBtnShadow: '0 2px 8px rgba(0, 0, 0, 0.3), 0 4px 12px rgba(0, 0, 0, 0.25)',
    floatingBtnBgHover: 'rgba(71, 85, 105, 0.7)',
    floatingBtnShadowHover: '0 4px 12px rgba(0, 0, 0, 0.35), 0 6px 20px rgba(0, 0, 0, 0.3)',
    floatingIconColor: '#e2e8f0',
    floatingIconColorHover: '#f8fafc',

    panelBg: 'rgba(15, 23, 42, 0.95)',
    panelBorder: 'rgba(51, 65, 85, 0.5)',
    panelHeaderBg: 'rgba(15, 23, 42, 0.9)',
    panelRadius: '12px',

    tabBg: 'rgba(30, 41, 59, 0.6)',
    tabItemBg: 'transparent',
    tabItemBgHover: 'rgba(51, 65, 85, 0.5)',
    tabItemBgActive: 'rgba(51, 65, 85, 0.8)',
    tabItemTextActive: '#60a5fa',

    overrides: {
        dialog: {
            headerBg: '#0f172a',
        },
        toolbar: {
            bg: 'rgba(30, 41, 59, 0.9)',
            buttonBg: 'rgba(51, 65, 85, 0.6)',
            buttonBgHover: 'rgba(71, 85, 105, 0.7)',
            buttonBgActive: '#3b82f6',
        },
        input: {
            bg: '#0f172a',
            bgFocus: '#1e293b',
            placeholder: '#64748b',
        },
    },
};

export function createThemeFromPartial(base: ThemeConfig, partial: Partial<ThemeConfig>): ThemeConfig {
    return {
        ...base,
        ...partial,
        overrides: {
            ...base.overrides,
            ...partial.overrides,
        },
    };
}

export function getThemeByName(name: string): ThemeConfig {
    switch (name) {
        case 'light':
            return lightTheme;
        case 'dark':
        default:
            return darkTheme;
    }
}
